import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import SubtleBadge from '@/components/common/SubtleBadge';
import { formatSourceDisplayType } from '../../utils/source-insights';

const TYPE_ICONS: Record<string, IconProp> = {
  You: 'user',
  Competitor: 'user-friends',
  UGC: 'users',
  Corporate: 'home',
  Editorial: 'book',
  Reference: 'link',
  Institutional: 'globe',
  Marketplace: 'shopping-cart',
  Directory: 'list',
  Other: 'folder',
  Unknown: 'question-circle',
};

export function SourceDisplayTypeBadge({ type }: { type: string }) {
  const color =
    type === 'You' ? 'success' : type === 'Competitor' ? 'warning' : type === 'Unknown' ? 'secondary' : 'primary';
  const icon = TYPE_ICONS[type] ?? 'tag';

  return (
    <SubtleBadge bg={color} pill className="fs--2 fw-normal">
      <FontAwesomeIcon icon={icon} transform="shrink-2" className="mx-1" />
      {formatSourceDisplayType(type)}
    </SubtleBadge>
  );
}
